// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__27skF","head":"Table_head__1UkES","col":"Table_col__1umzj"};